import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d14558e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "sms-modal-label"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { id: "booking-detail-modal-body" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Time")
], -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Summary", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = {
  key: 3,
  class: "mt-4"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Location", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 4 }
const _hoisted_22 = {
  key: 5,
  class: "mt-4"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Description", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Time")
], -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Summary", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = {
  key: 3,
  class: "mt-4"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Description", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Provisional", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Inspector")
], -1))
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Time")
], -1))
const _hoisted_46 = { key: 4 }
const _hoisted_47 = { key: 5 }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Address", -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 6,
  class: "mt-4"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Key collection", -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { key: 7 }
const _hoisted_54 = { key: 8 }
const _hoisted_55 = {
  key: 9,
  class: "mt-4"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Notes", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { key: 10 }
const _hoisted_59 = { key: 3 }
const _hoisted_60 = { class: "modal-footer" }

import $ from 'jquery';
import _get from 'lodash/get';
import { ref, computed, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import ContentEditable from "@/components/ContentEditable.vue";
import BookingDetail from "@/components/diary/BookingDetail.vue";

// Import your models or other external methods
import { Bookedby, Booking, CognitoUser, Dictionary, Landlord, Tenant } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingDetailModal',
  props: {
  editable: {
    type: Boolean,
    default: true,
  },
  id: String
},
  setup(__props, { expose: __expose }) {

const props = __props;

const store = useStore();

const cognitoUser = computed((): CognitoUser => store.getters['auth/cognitoUser']);
const dictionary = computed((): Dictionary => store.getters['dictionary/current']);

const saveBooking = (booking: Booking) => {
  return store.dispatch("diary/saveBookingFromScheduler", booking);
};

const realtime: any = inject('realtime');
const actProperty: any = inject('actProperty');

const channel = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

const booking = ref(new Booking());
const prepandkeybookings = ref<Booking[]>([]);


const title = ref("");
const titlenoteschanged = ref(false);
const bookingid = computed(() => booking.value.id);
const titlenotes = computed({
  get: () => booking.value.titlenotes,
  set: (val) => {
    booking.value.titlenotes = val;
    titlenoteschanged.value = true;
  }
});

// Methods
const init = (bookingData: Booking) => {
  booking.value = bookingData;
  title.value = actProperty.getBookingTitle(booking.value, dictionary.value);
  if (!bookingData.subtype) {
    prepandkeybookings.value = bookingData.subbookings.filter((f: Booking) => f.subtype === "Prep" || f.subtype === "Key");
  }
};

const masterReportType = computed(() => {
  return actProperty.formatReportType(booking.value.leadbooking?.jobtype, dictionary)
});

const pischeduler = computed(() => {
  const assignedGroups = _get(
    cognitoUser.value,
    'signInUserSession.accessToken.payload["cognito:groups"]',
    []
  );
  const isDiaryUser = assignedGroups.some(
    (assignedGroup: string) => ["DiaryUser"].includes(assignedGroup)
  );
  return (screen.width <= 760 && isDiaryUser);
});

const onAddressclick = () => {
  if (pischeduler.value) {
    let address = actProperty.formatAddress(booking.value.address, ", ");
    window.open(`http://maps.google.com/?q=${encodeURI(address)}`, '_blank', 'noreferrer');
  }
}


const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    let el = $(`#${props.id}`);
    el.show();
  }
}

const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
  }
  if (titlenoteschanged.value) {
    saveBooking(booking.value).then((b: Booking) => {
      channel.publish('appointmentChanged', { deviceid: deviceid, bookingid: b.id, source: 'Scheduler' });
      $(`#${props.id}`).hide();
    });
  }
  else {
    $(`#${props.id}`).hide();
  }
};

__expose({ init, show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`booking-detail-modal-label`",
    "aria-hidden": "true",
    style: {}
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", { 'modal-lg': booking.value.googleid }]),
      role: "document"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, [
            (booking.value.googleid)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createTextVNode("Google event "),
                  (booking.value.inspector)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, ": " + _toDisplayString(booking.value.inspector.name), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(title.value), 1))
          ]),
          (booking.value.jobtype && __props.editable)
            ? (_openBlock(), _createBlock(ContentEditable, {
                key: titlenotes.value,
                content: titlenotes.value,
                class: "ml-2 mr-2 d-inline-block col-md-9",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                onUpdate: _cache[1] || (_cache[1] = ($event: any) => (titlenotes.value = $event)),
                onDelete: _cache[2] || (_cache[2] = ($event: any) => (titlenotes.value = ''))
              }, null, 8, ["content"]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _withModifiers(hide, ["prevent"])
          }, _hoisted_9)
        ]),
        (_openBlock(), _createElementBlock("div", {
          class: "modal-body",
          key: bookingid.value
        }, [
          _createElementVNode("div", _hoisted_10, [
            (booking.value.googleid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  (booking.value.startdate || booking.value.enddate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(booking.value.starttime) + " to " + _toDisplayString(booking.value.endtime), 1))
                    : _createCommentVNode("", true),
                  (booking.value.summary)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                    : _createCommentVNode("", true),
                  (booking.value.summary)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(booking.value.summary), 1))
                    : _createCommentVNode("", true),
                  (booking.value.location)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                    : _createCommentVNode("", true),
                  (booking.value.location)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(booking.value.location), 1))
                    : _createCommentVNode("", true),
                  (booking.value.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                    : _createCommentVNode("", true),
                  (booking.value.description)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 6,
                        innerHTML: booking.value.description
                      }, null, 8, _hoisted_25))
                    : _createCommentVNode("", true)
                ]))
              : (booking.value.jobtype === 'Personal')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    (booking.value.startdate || booking.value.enddate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(booking.value.starttime) + " to " + _toDisplayString(booking.value.endtime), 1))
                      : _createCommentVNode("", true),
                    (booking.value.summary)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                      : _createCommentVNode("", true),
                    (booking.value.summary)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(booking.value.summary), 1))
                      : _createCommentVNode("", true),
                    (booking.value.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                      : _createCommentVNode("", true),
                    (booking.value.description)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 4,
                          innerHTML: booking.value.description
                        }, null, 8, _hoisted_36))
                      : _createCommentVNode("", true)
                  ]))
                : (booking.value.subtype === 'Key')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      (booking.value.provisional)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                        : _createCommentVNode("", true),
                      (booking.value.provisional)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, " Why: " + _toDisplayString(booking.value.provisionalnotes), 1))
                        : _createCommentVNode("", true),
                      _hoisted_42,
                      (booking.value.inspector)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(booking.value.inspector.name), 1))
                        : _createCommentVNode("", true),
                      (booking.value.leadbooking?.inspector)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(booking.value.leadbooking.inspector.name) + " - (" + _toDisplayString(masterReportType.value) + ") ", 1))
                        : _createCommentVNode("", true),
                      _hoisted_45,
                      (booking.value?.startdate || booking.value?.enddate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(booking.value.starttime) + " to " + _toDisplayString(booking.value.endtime), 1))
                        : _createCommentVNode("", true),
                      (booking.value?.leadbooking?.startdate || booking.value.leadbooking?.enddate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(booking.value?.leadbooking?.bookingdate) + " - " + _toDisplayString(booking.value?.leadbooking?.starttime) + " to " + _toDisplayString(booking.value?.leadbooking?.endtime) + " - (" + _toDisplayString(masterReportType.value) + ") ", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "mt-4",
                        onClick: onAddressclick
                      }, _hoisted_49),
                      _createElementVNode("div", { onClick: onAddressclick }, _toDisplayString(_unref(actProperty).formatAddress(booking.value.address, ", ")), 1),
                      (booking.value.leadbooking && booking.value.leadbooking.keypickup)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
                        : _createCommentVNode("", true),
                      (booking.value.leadbooking && booking.value.leadbooking.keypickup)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(booking.value.leadbooking.keypickup) + ": " + _toDisplayString(booking.value.leadbooking.customer.companyName) + " - " + _toDisplayString(booking.value.leadbooking.keypickupbranchname), 1))
                        : _createCommentVNode("", true),
                      (booking.value.leadbooking && booking.value.leadbooking.keypickup && booking.value.leadbooking.keypickup === 'From Agency')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_unref(actProperty).formatAddress(booking.value.leadbooking.keypickupfromaddress, ", ")), 1))
                        : _createCommentVNode("", true),
                      (booking.value.pinotes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_57))
                        : _createCommentVNode("", true),
                      (booking.value.pinotes)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(booking.value.pinotes), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (booking.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        (booking.value.subtype === 'Prep' || booking.value.subtype === 'Shared' || booking.value.subtype === 'Revisit')
                          ? (_openBlock(), _createBlock(BookingDetail, {
                              key: 0,
                              booking: booking.value,
                              leadbooking: booking.value.leadbooking
                            }, null, 8, ["booking", "leadbooking"]))
                          : (_openBlock(), _createBlock(BookingDetail, {
                              key: 1,
                              booking: booking.value,
                              leadbooking: booking.value,
                              prepandkeybookings: prepandkeybookings.value
                            }, null, 8, ["booking", "leadbooking", "prepandkeybookings"]))
                      ]))
                    : _createCommentVNode("", true)
          ])
        ])),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _withModifiers(hide, ["prevent"])
          }, " Close ")
        ])
      ])
    ], 2)
  ], 8, _hoisted_1))
}
}

})